import React from 'react';
import { t } from 'i18next';
import { toast } from 'react-toastify';

import Notification from 'components/Notification';
import { copyToBuffer } from 'components/utils';
import palette from 'palette';
import { NODE_ENV } from 'const';
import authStore from 'store/auth';
import commonStore from 'store/common';
import { c as CheckInCircle } from 'assets/svg/CheckInCircle.svg';
import { c as Alert } from 'assets/svg/Alert.svg';
import { c as Hourglass } from 'assets/svg/Hourglass.svg';

import { apiBaseUrl } from './utils';


const handleLogout = () => {
  Notification({
    image: <Alert fill={`rgba(${palette.uiColorsSystemYellow} / 1)`} height={32} width={32} />,
    title: t('ws.auth.logout'),
  });

  const { logout } = authStore.getState();

  logout();
};

const handleAppUpdate = () => {
  const { setAppIsUpdated } = commonStore.getState();

  setAppIsUpdated(true);
};

const closeCode = 4999;

class WS {
  instance = null;

  count = 0;

  store = null;

  token = null;

  constructor() {
    this.store = authStore;
    this.store.subscribe(this.handleChange.bind(null, authStore));
  }

  init = () => {
    const isDev = NODE_ENV === 'development';
    const { token } = this.store.getState();
    this?.instance?.close(closeCode);
    if (!token) return;
    const baseUrl = new URL(apiBaseUrl);
    this.instance = new WebSocket(`${isDev ? 'ws' : 'wss'}://${baseUrl.host || globalThis.location.host}/${isDev ? 'local/' : ''}ws?bearer=${token}`);

    this.instance.addEventListener('open', this.onOpen);
    this.instance.addEventListener('close', this.onClose);
    this.instance.addEventListener('message', this.onMessage);
    // this.instance.addEventListener('error', this.onClose);

    return this;
  };

  onOpen = () => {
    this.count = 0;
    console.log('WS Connected...');
  };

  onClose = (e) => {
    const { code } = e;
    if (code === closeCode) return;
    this.count += 1;
    const delay = Math.min(2 ** this.count, 10);

    if (this.count > 10) return undefined;

    setTimeout(() => {
      this.init(this.store);
    }, delay * 1000);
  };

  onMessage = (e) => {
    const res = JSON.parse(e.data);
    const generationId = res?.data?.generationId;

    switch (res.event) {
      case 'catalog_generation_progress': {
        if (toast.isActive(generationId)) {
          toast.update(generationId, { progress: Number(res.data.progress) / 100 });
        } else {
          Notification({
            image: <Hourglass color={`rgba(${palette.uiColorsSystemBlue} / 1)`} height={32} width={32} />,
            title: t('ws.catalog.start_catalog_generate'),
          }, { autoClose: false, progress: Number(res.data.progress), toastId: generationId });
        }
        break; 
      }
      case 'catalog_generated': {
        toast.dismiss(generationId);
        Notification({
          image: <CheckInCircle color={`rgba(${palette.uiColorsSystemGreen} / 1)`} height={32} width={32} />,
          title: t(`ws.catalog.${res.event}`),
          interactive: (
            <>
              <a href={res.data.link} target="_blank" rel="noreferrer">{t('Download PDF')}</a>
              <span> | </span>
              <a onClick={() => copyToBuffer(res.data.link)}>{t('Copy link')}</a>
            </>
          ),
        }, { autoClose: false });
        break;
      } 
      case 'logout':
        handleLogout();
        break;

      case 'web_client_updated':
        handleAppUpdate();
        break;

      default:
        break;
    }
  };

  handleChange = () => {
    const prev = this.token;
    this.token = this.store.getState().token;

    if (prev !== this.token) this.init();
  };
}

export default WS;
